import ApiService from "@/core/services/ApiService";
import Config from "@/core/config/ApiConfig";

export default {
  getSalesCreditList(params) {
    return ApiService.post(
      Config.fulfillmentApiUrl + "/api/fulfillment/sales-credit/index",
      params
    );
  },
  print(params) {
    return ApiService.post(
      Config.fulfillmentApiUrl + "/api/fulfillment/sales-credit/print",
      params,
      { responseType: "blob" }
    );
  },
  print2(params) {
    return ApiService.post(
      Config.fulfillmentApiUrl + "/api/fulfillment/sales-credit/print",
      params
    );
  },
};
